import { GetterTree } from 'vuex';
import { State } from '../../state';

export const getters: GetterTree<unknown, State> = {
  getRequestedInformation: (_state, _getters, rootState): boolean => {
    return rootState.showRequestedInformationForm;
  },
};
